module.exports = __webpack_public_path__ + "static/media/sandwich-image-1.e6a4f2ec.png";